import 'SF/note/data/NoteTypeStore.js';
import 'SF/note/NoteEditor.js';
import 'SF/note/NotePopup.js';
import 'SF/note/PermissionsPanel.js';
import 'SF/note/TypeUtil.js';
import 'SF/note/bundle.js';
import 'SF/note/data/CloseLoopCommentNoteTypeStore.js';
import 'SF/note/data/EmailCommentNoteTypeStore.js';
import 'SF/note/data/EmailProviderCommentNoteTypeStore.js';
import 'SF/note/data/FlagCommentNoteTypeStore.js';
import 'SF/note/data/KudoCommentNoteTypeStore.js';
import 'SF/note/data/NoteCreatedByRoleStore.js';
import 'SF/note/data/NoteModel.js';
import 'SF/note/data/ReferralCommentNoteTypeStore.js';
import 'SF/note/data/SystemAndStudentNoteTypeStore.js';
import 'SF/note/data/ToDoCommentNoteTypeStore.js';
